<template>
    <list-widget title="결제사" minWidth="160" #default="{ attrs }">
        <v-select v-model="query['payment.openbank.pg']" v-bind="{ ...attrs, items }" dense flat solo hide-details @input="emit" />
    </list-widget>
</template>

<script>
import { OPENBANK_PG_TEXTS } from "@/store/nshop";
import ListWidget from "../../dumb/list/list-widget.vue";

// 내 통장 결제가 쿠콘·KG이니시스 결제창을 번갈아 쓰므로 어느 결제사인지로 주문을 거른다.
// 값은 주문의 payment.openbank.pg 와 같다. 배정 이전 주문(pg 없음)은 서버가 쿠콘으로 취급한다.
const items = [{ value: null, text: "전체" }].concat(Object.entries(OPENBANK_PG_TEXTS).map(([value, text]) => ({ value, text })));

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["payment.openbank.pg"]: query?.["payment.openbank.pg"] || null,
});

export default {
    components: {
        ListWidget,
    },
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["payment.openbank.pg"]) delete query["payment.openbank.pg"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
